import Cookies from "js-cookie";
import {routes, useGetDataById} from "../routes/api";
import {useContext, useEffect, useState} from "react";
import {EnumContext} from "../components/enumContext";
import Typography from "@mui/material/Typography";
import {Card, CardActionArea, CardHeader, Grid, IconButton} from "@mui/material";
import {PositionMap} from "../components/map";
import CloseIcon from "@mui/icons-material/Close";
import {UnitMapHeaders} from "../util/getFields";
import {grey} from "@mui/material/colors";
import Box from "@mui/material/Box";
import {convertUnitData, updateData} from "../util/util";
import {useLocation, useNavigate} from "react-router-dom";
import {unitFields} from "../util/modelFields";

export default function UnitMap({mapData, setMapView}) {
    const token = Cookies.get('token');
    const route = routes.unit;
    const {enums} = useContext(EnumContext);
    const navigate = useNavigate();
    const location = useLocation();

    const [badData, setBadData] = useState(false);
    const [unitData, setUnitData] = useState({});
    const [open, setOpen] = useState(false);
    const [currUnit, setCurrUnit] = useState(null);

    const {
        data: detailData,
        loading: detailLoading,
        statusCode: detailStatus,
        handleCall: detailCall
    } = useGetDataById(token, route, 0);

    const fetchById = async (id) => {
        try {
            await detailCall({updatedUrl: `${route}/${id}/`})
        } catch (error) {
            console.error('Error fetching unit data:', error);
        }
    }

    const transformData = (detail) => {
        const newData = convertUnitData(updateData(detail.data, UnitMapHeaders, 'u', enums), unitFields.fields);
        return {
            ...newData,
            Camera: String(detail.Camera.map((item) => item.c_sn)),
            Firmware: detail.Firmware?.f_name,
            Application: detail.Application?.app_name,
        }
    }

    useEffect(() => {
        if (detailStatus === 0) {
            return;
        }
        if (detailStatus === 204 || typeof detailData === 'string' || Object.keys(detailData).length === 0) {
            setBadData(true);
        } else {
            setUnitData(transformData(detailData));
        }
    }, [detailStatus, detailData]);

    const handleMapClick = async (unit) => {
        setCurrUnit(unit.id);
        setBadData(false);
        await fetchById(unit.id);
        setOpen(true);
    }

    const handleClick = (id) => {
        window.history.replaceState({from: location}, '');
        navigate(`/unit/${id}`, {state: {from: location}});
    };

    return <Grid size={12}>
        <Typography variant='overline' sx={{display: "flex", justifyContent: "center", mb: 1}}>
            units without latitude and longitude are not shown on map
        </Typography>
        <Card sx={{
            borderRadius: '16px',
            width: '100%',
            height: '80vh',
            display: 'flex',
            flexDirection: 'row'
        }}>
            <Box sx={{flex: 2, height: '100%'}}>
                <PositionMap units={mapData} handleClick={handleMapClick} setMapView={setMapView}/>
            </Box>
            {open && <Card sx={{borderRadius: '0px', flex: 1}}>
                <CardHeader
                    title='Unit Detail'
                    action={
                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </IconButton>
                    }
                />
                <CardActionArea onClick={() => handleClick(currUnit)}
                                sx={{maxHeight: '90%', overflowY: 'auto'}}>
                    <Grid container
                          spacing={1}
                          sx={{margin: 'auto', mb: 2, width: '90%'}}
                          alignItems="center"
                          justifyContent="center"
                    >
                        {badData ?
                            <Grid size={12}>
                                <Typography variant="body1" color={grey[700]}>
                                    Error retrieving details. Please try again later.
                                </Typography>
                            </Grid> :
                            Object.entries(unitData).map(([key, value]) => (
                                [
                                    <Grid size={5} key={key} sx={{mb: 1}}>
                                        <Typography variant="body1" color={grey[700]}>
                                            {key}
                                        </Typography>
                                    </Grid>,
                                    <Grid size={7} key={`${key}-value`} sx={{mb: 1}}>
                                        <Typography variant="body1">
                                            {value}
                                        </Typography>
                                    </Grid>
                                ]
                            ))}
                    </Grid>
                </CardActionArea>
            </Card>}
        </Card>
    </Grid>
}